module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./md2vue.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/md2vue.md
// module id = pAUz
// module chunks = 0